import { l as r } from "../../lodash-lyheMOjd.mjs";
const s = {
  asc: "ASC",
  desc: "DESC"
};
function c(t) {
  return t ? r.invertBy(s, (o) => o)[t] : void 0;
}
export {
  c as getSort,
  s as sortingMap
};
//# sourceMappingURL=type.js.map
